import axios from 'axios';
import { hasAuthAccessParams } from '../types/guards';
import { processResponse, processError, privateRequestParams } from '../utils';
export default class HeroSessionAPI {
    static startSession(accessParams) {
        if (!hasAuthAccessParams(accessParams)) {
            throw new Error('private access params missing');
        }
        return axios
            .post(accessParams.API_ENDPOINT + 'frontend/session-start/', {}, privateRequestParams(accessParams))
            .then(function (response) {
            return processResponse(response);
        })
            .catch(function (error) {
            return processError(error);
        });
    }
}
//# sourceMappingURL=index.js.map